/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const chevronDownSmall = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path d="m15.99 10.889-3.988 3.418-3.988-3.418.976-1.14 3.012 2.582 3.012-2.581.976 1.139Z" />
	</SVG>
);

export default chevronDownSmall;
